// Location data for multi-site support
export type LocationStatus = "accepting" | "full";

export type PaletteId = "a" | "b";

export interface LocationData {
  id: string;
  name: string;
  shortName: string;
  address: string;
  cityState: string;
  primaryPhone: string; // Main contact number for call buttons
  secondaryPhone?: string; // Alternate / backup line, shown subtly under the main number
  phone: string; // Home phone
  email: string;
  licenseNumber: string;
  licenseImage: string;
  providerName: string;
  status: LocationStatus;
  mapsUrl: string;
  mapsEmbedUrl: string;
  paletteId: PaletteId;
}

export const LOCATIONS: Record<string, LocationData> = {
  lynnwood: {
    id: "lynnwood",
    name: "Dawit Solomon Adult Family Home LLC - Lynnwood",
    shortName: "Lynnwood",
    address: "4516 145th Pl SW",
    cityState: "Lynnwood, WA 98087",
    primaryPhone: "206-557-0011", // Main contact number
    secondaryPhone: "425-921-6150", // Alternate / backup line
    phone: "206-557-0011", // Home phone
    email: "dawitsolomonafh@gmail.com",
    licenseNumber: "758391",
    licenseImage: "/images/license.jpg",
    providerName: "Alemtsehay Yirgu",
    status: "accepting",
    mapsUrl: "https://www.google.com/maps/place/4516+145th+Pl+SW,+Lynnwood,+WA+98087/@47.8663969,-122.2974478,17z",
    mapsEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2676.6161475718745!2d-122.2974477878477!3d47.8663968698811!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5490045d76c7c117%3A0xcef36cc1b9f73043!2s4516%20145th%20Pl%20SW%2C%20Lynnwood%2C%20WA%2098087!5e0!3m2!1sen!2sus!4v1768863026828!5m2!1sen!2sus",
    paletteId: "a",
  },
  seattle: {
    id: "seattle",
    name: "Dawit Solomon Adult Family Home LLC - Seattle",
    shortName: "Seattle",
    address: "11555 17th Ave NE",
    cityState: "Seattle, WA 98125",
    primaryPhone: "206-557-0011", // Main contact number
    secondaryPhone: "425-921-6150", // Alternate / backup line
    phone: "206-557-0011", // Office phone
    email: "dawitsolomonafh@gmail.com",
    licenseNumber: "[License # to be provided]",
    licenseImage: "/images/license-seattle.jpg",
    providerName: "Alemtsehay Yirgu",
    status: "full",
    // Form submissions go to the same-origin /api/lead function.
    mapsUrl: "https://www.google.com/maps/place/11555+17th+Ave+NE,+Seattle,+WA+98125/@47.7137818,-122.3128072,17z",
    mapsEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5368.975508125776!2d-122.31280718785494!3d47.71378178044968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5490115e797f4dcf%3A0x2145912fa4a8d323!2s11555%2017th%20Ave%20NE%2C%20Seattle%2C%20WA%2098125!5e0!3m2!1sen!2sus!4v1768862994258!5m2!1sen!2sus",
    paletteId: "b",
  },
};

export const DEFAULT_LOCATION = "lynnwood";

// Helper to get the other location
export function getOtherLocation(currentId: string): LocationData {
  return currentId === "lynnwood" ? LOCATIONS.seattle : LOCATIONS.lynnwood;
}
